export interface ApiResponse<T> {
  ok: boolean;
  status: number;
  body: T | null;
}

export const api = {
  async get<T>(path: string): Promise<ApiResponse<T>> {
    try {
      const res = await fetch(path, {
        headers: { Accept: "application/json" },
      });
      let body: T | null = null;
      const ct = res.headers.get("content-type") ?? "";
      if (ct.includes("application/json")) {
        try {
          body = (await res.json()) as T;
        } catch {
          /* ignore parse error */
        }
      }
      return { ok: res.ok, status: res.status, body };
    } catch {
      return { ok: false, status: 0, body: null };
    }
  },

  async post<T>(path: string, body: unknown): Promise<ApiResponse<T>> {
    try {
      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body),
      });
      let responseBody: T | null = null;
      const ct = res.headers.get("content-type") ?? "";
      if (ct.includes("application/json")) {
        try {
          responseBody = (await res.json()) as T;
        } catch {
          /* ignore parse error */
        }
      }
      return { ok: res.ok, status: res.status, body: responseBody };
    } catch {
      return { ok: false, status: 0, body: null };
    }
  },

  async patch<T>(path: string, body: unknown): Promise<ApiResponse<T>> {
    try {
      const res = await fetch(path, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body),
      });
      let responseBody: T | null = null;
      const ct = res.headers.get("content-type") ?? "";
      if (ct.includes("application/json")) {
        try {
          responseBody = (await res.json()) as T;
        } catch {
          /* ignore parse error */
        }
      }
      return { ok: res.ok, status: res.status, body: responseBody };
    } catch {
      return { ok: false, status: 0, body: null };
    }
  },
};
